module.exports = __webpack_public_path__ + "static/media/m_lipshape_downturned.ddd91284.png";